import { Theme } from '@mui/material'

const useStyles = {
  banner: {
    display: 'block',
    marginLeft: '-16px',
    width: 'calc(100% + 32px)',
  },
  sidewalkText: {
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: '33px',
    letterSpacing: 0,
    marginTop: 4,
    strong: {
      fontStyle: 'italic',
    },
  },
  noteText: {
    marginTop: 3,
    marginBottom: 2,
  },
  instructionText: {
    marginTop: 2,
    marginBottom: 2,
  },
  sidewalkAccordion: {
    boxShadow: 'none',
    border: 'none',
    // remove default divider line
    '&:before': {
      display: 'none',
    },
  },
  sidewalkAccordionSummary: (theme: Theme) => ({
    flexDirection: 'row-reverse',
    minHeight: 'auto',
    paddingY: 0,
    paddingX: 0,
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(1, 2),
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: theme.spacing(1, 2),
    },
    '&.Mui-expanded': {
      minHeight: 'auto',
      '& .MuiSvgIcon-root': {
        transform: 'rotate(-90deg)',
      },
    },
  }),
  accordionIcon: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),
  accordionTitle: (theme: Theme) => ({
    color: theme.palette.common.white,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
  }),
  orderedList: {
    paddingLeft: '1.2rem',
    margin: 0,
  },
}

export default useStyles
